<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="vm-list-container">
  <div
    class="elevate"
    [style.visibility]="vmApiResponded ? 'visible' : 'hidden'"
    >
    <div>
      <div class="header-row">
        <div class="search-span">
          <mat-form-field>
            <input
              matInput
              name="vmSearch"
              placeholder="Search"
              [formControl]="filterControl"
              />
            @if (filterControl.value) {
            <button matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
              <mat-icon class="mdi-24px" fontIcon="mdi-close-circle-outline"></mat-icon>
            </button>
            }
          </mat-form-field>
        </div>
        <div class="select-span">
          <mat-checkbox
            [(ngModel)]="showSelectedOnly"
            class="margin-left-50"
            (change)="filterControl.setValue('')"
          ></mat-checkbox>
          <span style="margin-left: 10px"
            >View Selected (<b
            ><u>{{ selectedVms.length }}</u></b
            >)</span
            >
            <button
              mat-button
              (click)="checkAll()"
              title="Select all displayed VMs"
              class="margin-left-100"
              [disabled]="showSelectedOnly"
              >
              <mat-icon fontIcon="mdi-checkbox-marked"></mat-icon>
              All
            </button>
            <button
              mat-button
              (click)="uncheckAll()"
              title="Unselect all displayed VMs"
              class="margin-left-50"
              >
              <mat-icon fontIcon="mdi-checkbox-blank-outline"></mat-icon>
              None
            </button>
          </div>
        </div>
        <div class="cssLayoutRowStartCenter">
          @if (!showSelectedOnly) {
            <div class="flex-container">
              @for (vm of vmList; track vm) {
                <div class="item-container">
                  <div>
                    <div id="wrapper">
                      <div id="context">
                        <mat-checkbox
                          [checked]="!!selectedVms && selectedVms.includes(vm.id)"
                          (change)="onCheckBoxChange($event, vm.id)"
                        ></mat-checkbox>
                        {{ vm.name }}
                        <button
                          mat-icon-button [attr.aria-label]="'Open ' + vm.name"
                          (click)="openInTab(vm.url); $event.stopPropagation()"
                          title="Open {{ vm.name }}"
                          class="icon-20px"
                          >
                          <mat-icon
                            class="icon-20px"
                            fontIcon="mdi-open-in-new"
                          ></mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
      @if (showSelectedOnly) {
        <div>
          @for (vm of selectedVmList(); track vm) {
            <div class="flex-container">
              <div>
                <div id="wrapper">
                  <div id="context">
                    <mat-checkbox
                      [checked]="!!selectedVms && selectedVms.includes(vm.id)"
                      (change)="onCheckBoxChange($event, vm.id)"
                    ></mat-checkbox>
                    {{ vm.name }}
                    <button
                      mat-icon-button [attr.aria-label]="'Open ' + vm.name"
                      (click)="openInTab(vm.url); $event.stopPropagation()"
                      title="Open {{ vm.name }}"
                      class="icon-20px"
                      >
                      <mat-icon
                        class="icon-20px"
                        fontIcon="mdi-open-in-new"
                      ></mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
    <div
      class="elevate"
      [style.visibility]="vmApiResponded ? 'hidden' : 'visible'"
      >
      <label>The Steamfitter API or VM API is not currently reachable.</label>
    </div>
  </div>
